import { lazy } from 'react';

// Componenti della shell operatore, lazy-loaded in un chunk separato così che i
// ruoli desktop non li scarichino. Definiti qui (file di soli componenti) per
// non violare react-refresh/only-export-components in routes/index.tsx.
export const OperatoreLayout = lazy(() => import('../components/layout/OperatoreLayout'));
export const RegistraScaricoPage = lazy(() => import('../pages/operatore/RegistraScaricoPage'));
export const RegistraProduzionePage = lazy(() => import('../pages/operatore/RegistraProduzionePage'));
